/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TarifCommandDto } from './TarifCommandDto';
import {
    TarifCommandDtoFromJSON,
    TarifCommandDtoFromJSONTyped,
    TarifCommandDtoToJSON,
    TarifCommandDtoToJSONTyped,
} from './TarifCommandDto';

/**
 * Modification d'une commission de garantie.
 * @export
 * @interface UpdateCommissionGarantieCommand
 */
export interface UpdateCommissionGarantieCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateCommissionGarantieCommand
     */
    natureRemunerationId: string;
    /**
     * 
     * @type {TarifCommandDto}
     * @memberof UpdateCommissionGarantieCommand
     */
    tarif: TarifCommandDto;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommissionGarantieCommand
     */
    beneficiairePersonneId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCommissionGarantieCommand
     */
    compteBancaireId?: string | null;
}

/**
 * Check if a given object implements the UpdateCommissionGarantieCommand interface.
 */
export function instanceOfUpdateCommissionGarantieCommand(value: object): value is UpdateCommissionGarantieCommand {
    if (!('natureRemunerationId' in value) || value['natureRemunerationId'] === undefined) return false;
    if (!('tarif' in value) || value['tarif'] === undefined) return false;
    return true;
}

export function UpdateCommissionGarantieCommandFromJSON(json: any): UpdateCommissionGarantieCommand {
    return UpdateCommissionGarantieCommandFromJSONTyped(json, false);
}

export function UpdateCommissionGarantieCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCommissionGarantieCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'natureRemunerationId': json['natureRemunerationId'],
        'tarif': TarifCommandDtoFromJSON(json['tarif']),
        'beneficiairePersonneId': json['beneficiairePersonneId'] == null ? undefined : json['beneficiairePersonneId'],
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
    };
}

export function UpdateCommissionGarantieCommandToJSON(json: any): UpdateCommissionGarantieCommand {
    return UpdateCommissionGarantieCommandToJSONTyped(json, false);
}

export function UpdateCommissionGarantieCommandToJSONTyped(value?: UpdateCommissionGarantieCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'natureRemunerationId': value['natureRemunerationId'],
        'tarif': TarifCommandDtoToJSON(value['tarif']),
        'beneficiairePersonneId': value['beneficiairePersonneId'],
        'compteBancaireId': value['compteBancaireId'],
    };
}

